import MSegmentedControl from './MSegmentedControl.vue';

MSegmentedControl.install = (app) => {
  app.component('MSegmentedControl', MSegmentedControl);
};

export { MSegmentedControl };
